import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import PlayerExclusionSwitcher from './player-exclusion-switcher';
import Action from 'actions';
import ExclusionInfo from './atoms/exclusion-info';

class PlayerExclusionsStateList extends Component {
    onClick(isActive) {
        const {playerId} = this.props;
        this.props.dispatch(
            Action.set('SettingPopupState', {
                playerId,
                isActive,
                settingName: 'exclusion',
            }),
        );
    }

    getTooltipByMode(mode) {
        const {players, playerId} = this.props;
        const player = players.getPlayer(playerId);

        const tooltip = [];
        if (player.isExcludedByPoints(mode.getRole())) {
            tooltip.push(` ${mode.getLabel()} Fantasy Points`);
        }
        if (player.isExcludedBySalary(mode.getRole())) {
            tooltip.push(` ${mode.getLabel()} Salary`);
        }
        return tooltip;
    }

    render() {
        const {playerId, playersExclusion, playerSettingPopup, modesConfig} = this.props;

        const modes = modesConfig.all({asArr: true});

        const isActive = playerSettingPopup.isActive(playerId, 'exclusion');
        const isExcludedAnywhere = playersExclusion.isExcludedAnywhere(playerId);

        return (
            <div className={`checkbox-btn-holder${isActive ? ' active' : ''}`}>
                <button
                    type="button"
                    className={`checkbox-btn${!isExcludedAnywhere ? ' active' : ''}`}
                    onClick={() => this.onClick(!isActive)}
                    title={isExcludedAnywhere ? 'Exclude enabled' : 'Exclude disabled'}
                >
                    {isExcludedAnywhere ? 'Exclude enabled' : 'Exclude disabled'}
                </button>
                <ul className="checkbox-btn-drop">
                    {modes.map((mode) => {
                        const tooltip = this.getTooltipByMode(mode);
                        if (!isEmpty(tooltip)) {
                            return (
                                <li key={mode.getRole() + playerId}>
                                    <ExclusionInfo tooltip={tooltip} />
                                    <div>{mode.getLabel()}</div>
                                </li>
                            );
                        }

                        return (
                            <li key={mode.getRole() + playerId} onClick={() => this.onClick(!isActive)}>
                                <PlayerExclusionSwitcher
                                    className={`checkbox-btn`}
                                    playerId={playerId}
                                    activeMode={mode.getRole()}
                                />
                                <span>{mode.getLabel()}</span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {playersData, sportConfig, modesConfig, playersExclusion, playerSettingPopup} = state;
    return {
        players: playersData.players,
        sportConfig,
        modesConfig,
        playersExclusion,
        playerSettingPopup,
    };
}

export default connect(mapStatesToProps)(PlayerExclusionsStateList);
